import Grid from '@mui/material/Grid2';
import { MailServerSettings } from './MailServerSettings';
import { BasketReminderSettings } from './BasketReminderSettings';
import { OrderReminderSettings } from './OrderReminderSettings';
import { StockAlertSettings } from './StockAlertSettings';

export const MailSettings = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <MailServerSettings />
      </Grid>

      <Grid size={{ xs: 12, lg: 6 }}>
        <OrderReminderSettings />
      </Grid>

      <Grid size={{ xs: 12, lg: 6 }}>
        <BasketReminderSettings />
      </Grid>

      <Grid size={{ xs: 12, lg: 6 }}>
        <StockAlertSettings />
      </Grid>
    </Grid>
  );
};
